import React, { useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const AddFormLibrary = ({ Show, Hide, Title, getStudyFormLibraryData, studyId }) => {
  const [libraryName, setFormLibraryName] = useState("");
  const [libraryLabel, setFormLibraryLable] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewStudyFormLibrary = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.label = libraryLabel;
    userData.name = libraryName;
    userData.studyId = studyId;
    let data = await cdiscManagementService.addNewStudyFormLibrary(userData);
    if (data?.statusCode === 200) {
      getStudyFormLibraryData();
      setFormLibraryName("");
      setFormLibraryLable("");
      Hide();
    }
    setButtonLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">
            Form Label <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={libraryLabel}
            onChange={(e) => setFormLibraryLable(e.target.value)}
            placeholder="Enter Library Lable"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">
            Form Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={libraryName}
            onChange={(e) => setFormLibraryName(e.target.value)}
            placeholder="Enter Library Name"
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="text-end p-2 border-top">
        <button
          disabled={buttonLoader || !libraryName || !libraryLabel}
          onClick={addNewStudyFormLibrary}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Adding...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default AddFormLibrary;
